import { Input, Form, InputRef, Space } from 'antd';
import FormDrawer from '../common/formdrawer';
import PageVersionStatus from './pageversionstatus';
import CancelButton from '../common/cancelbutton';
import FormButton from '../common/formbutton';
import { PlusOutlined } from '@ant-design/icons';
import React from 'react';

interface CreatePageVersionFormProps {
  open: boolean;
  onClose: () => void;
  onCreate: (values: { name: string }) => void;
  nameInputRef?: React.RefObject<InputRef | null>;
  createButtonRef?: React.RefObject<HTMLDivElement | null>;
  isTourOpen?: boolean;
}

const CreatePageVersionForm: React.FC<CreatePageVersionFormProps> = ({
  open,
  onClose,
  onCreate,
  nameInputRef,
  createButtonRef,
  isTourOpen = false,
}) => {
  const [form] = Form.useForm<{ name: string }>();
  const initialStatus = 'draft';

  const handleCreate = (values: { name: string }) => {
    onCreate(values);
  };

  const handleClose = () => {
    form.resetFields();
    onClose();
  };

  const footer = (
    <div style={{ textAlign: 'right' }}>
      <Space>
        <CancelButton onClick={handleClose} />
        <div ref={createButtonRef}>
          <FormButton
            title="Create"
            icon={<PlusOutlined />}
            disableClick={isTourOpen}
            forceShow={isTourOpen}
            onClick={() => {
              if (isTourOpen) return;
              form
                .validateFields()
                .then((values) => {
                  form.resetFields();
                  handleCreate(values);
                })
                .catch((err) => console.log(err));
            }}
          />
        </div>
      </Space>
    </div>
  );


  return (
    <FormDrawer
      title="Create New PageVersion"
      open={open}
      onClose={handleClose}
      onSave={() => { }}
      form={form}
      footer={footer}
    >
      <PageVersionStatus status={initialStatus} />
      <Form.Item
        name="name"
        label="Name"
        rules={[
          {
            required: true,
            message: 'Please enter a name for the new page version!',
          },
        ]}
      >
        <Input placeholder="Enter new pageversion name" ref={nameInputRef} />
      </Form.Item>
    </FormDrawer>
  );
};

export default CreatePageVersionForm;